var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component, useMemo } from 'react';
import { computeCartesianTicks } from '../lib/compute';
import moment from 'moment';

var Axis = (_temp2 = _class = function (_Component) {
    _inherits(Axis, _Component);

    function Axis() {
        var _temp, _this, _ret;

        _classCallCheck(this, Axis);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.renderLabel = function (value, format) {

            if (format === "MONTH") {
                var month = moment(value).format('MMMM');

                var classNames = [];

                classNames.push('tick__label');

                var className = classNames.join(' ');

                return React.createElement(
                    'g',
                    { className: className },
                    React.createElement(
                        'text',
                        { className: 'tick__month' },
                        month
                    )
                );
            }

            if (format === "WEEK") {

                var w1 = moment(value).format();
                var w2 = moment(value).endOf("week").format();

                var _classNames = [];

                _classNames.push('tick__label');

                var date1 = moment(w1).format('DD.MM');
                var date2 = moment(w2).format('DD.MM');

                var w = moment(w1).isoWeek();

                var _className = _classNames.join(' ');

                return React.createElement(
                    'g',
                    { className: _className },
                    React.createElement(
                        'text',
                        { className: 'tick__start' },
                        date1,
                        '\u2013'
                    ),
                    React.createElement(
                        'text',
                        { className: 'tick__end' },
                        date2
                    )
                );
            }

            if (format === "DATE") {

                var year = moment(value).format('Y');
                var _month = moment(value).format('MMM');
                var day = moment(value).format('DD');

                var _classNames2 = [];

                _classNames2.push('tick__label');

                var _className2 = _classNames2.join(' ');

                return React.createElement(
                    'g',
                    { className: _className2 },
                    React.createElement(
                        'text',
                        { className: 'tick__day' },
                        day
                    ),
                    React.createElement(
                        'text',
                        { className: 'tick__month' },
                        _month
                    )
                );
            }

            if (format === "HOUR") {
                var hour = moment(value).format('HH:mm');

                return React.createElement(
                    'text',
                    { className: 'tick__label' },
                    hour
                );
            }

            if (format === "MINUTE") {
                var _hour = moment(value).format('HH:mm');

                return React.createElement(
                    'text',
                    { className: 'tick__label' },
                    _hour
                );
            }

            if (format === "PERCENT") {
                value = parseFloat(value);
                value = value.toFixed(0) + "%";

                return React.createElement(
                    'text',
                    { className: 'tick__label' },
                    value
                );
            }

            if (format === "TIME") {

                var time = moment().startOf('day').add(value, "seconds").format('H:m:ss');

                var split = time.split(":");

                var hours = split[0];
                var minutes = split[1];
                var seconds = split[2];

                if (hours >= 1) {
                    value = hours + 'h ' + minutes + 'm ' + seconds + 's';
                } else {
                    value = minutes + 'm ' + seconds + 's';
                }

                return React.createElement(
                    'text',
                    { className: 'tick__label' },
                    value
                );
            }

            if (format === "INTEGER") {

                value = new Intl.NumberFormat('de-DE').format(value);

                return React.createElement(
                    'text',
                    { className: 'tick__label' },
                    value
                );
            }

            return React.createElement(
                'text',
                { className: 'tick__label' },
                value
            );
        }, _this.renderTick = function (props, index) {
            var _this$props = _this.props,
                axis = _this$props.axis,
                position = _this$props.position,
                scale = _this$props.scale,
                format = _this$props.format,
                dimension = _this$props.dimension,
                startDate = _this$props.startDate,
                endDate = _this$props.endDate;
            var x = props.x,
                y = props.y,
                lineX = props.lineX,
                lineY = props.lineY,
                textX = props.textX,
                textY = props.textY,
                textAnchor = props.textAnchor,
                textBaseline = props.textBaseline,
                rotate = props.rotate,
                value = props.value;


            if (format === "STRING" && dimension === "ga:nthMonth" && startDate) {
                format = "MONTH";
                value = moment(startDate).startOf('month').add(value, "months");
            }

            if (format === "STRING" && dimension === "ga:nthWeek" && startDate) {
                format = "WEEK";
                value = moment(startDate).startOf('week').add(value, "weeks");
            }

            if (format === "STRING" && dimension === "ga:nthDay" && startDate) {
                format = "DATE";
                value = moment(startDate).add(value, "days");
            }

            if (format === "STRING" && dimension === "ga:nthHour" && startDate) {
                format = "HOUR";
                value = moment(startDate).add(value, "hours");
            }

            if (format === "STRING" && dimension === "ga:nthMinute" && startDate) {
                format = "MINUTE";
                value = moment(startDate).add(value, "minutes");
            }

            var transform = "translate(" + x + "," + y + ")";

            var classNames = [];

            classNames.push('tick');
            classNames.push('tick--' + axis);
            classNames.push('tick--' + position);
            classNames.push('tick--' + format.toLowerCase());

            if (dimension && dimension.includes("ga:")) {
                classNames.push('tick--' + dimension.replace("ga:", ""));
            }

            if (format === "DATE") {
                classNames.push('tick--month-' + moment(value).format('M'));
                classNames.push('tick--day-' + moment(value).format('D'));
            }

            var className = classNames.join(' ');

            return React.createElement(
                'g',
                { transform: transform, className: className },
                React.createElement('line', { className: 'tick__line', x1: 0, x2: lineX, y1: 0, y2: lineY }),
                _this.renderLabel(value, format)
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    Axis.prototype.render = function render() {
        var _this2 = this;

        var _props = this.props,
            axis = _props.axis,
            position = _props.position,
            x = _props.x,
            y = _props.y,
            scale = _props.scale,
            ticksPosition = _props.ticksPosition,
            tickValues = _props.tickValues,
            tickSize = _props.tickSize,
            tickPadding = _props.tickPadding,
            tickRotation = _props.tickRotation;


        var transform = "translate(" + x + "," + y + ")";
        var className = "axis  axis--" + axis + " axis--" + position;

        var _computeCartesianTick = computeCartesianTicks({
            axis: axis,
            scale: scale,
            ticksPosition: ticksPosition,
            tickValues: tickValues,
            tickSize: tickSize,
            tickPadding: tickPadding,
            tickRotation: tickRotation
        }),
            ticks = _computeCartesianTick.ticks,
            textAlign = _computeCartesianTick.textAlign,
            textBaseline = _computeCartesianTick.textBaseline;

        return React.createElement(
            'g',
            { transform: transform, className: className },
            ticks.map(function (tick, index) {
                return _this2.renderTick(_extends({
                    rotate: tickRotation,
                    textBaseline: textBaseline,
                    textAnchor: textAlign
                }, tick), index);
            })
        );

        return React.createElement(
            'g',
            { transform: transform, className: className },
            ticks.map(this.renderTick)
        );
    };

    return Axis;
}(Component), _class.defaultProps = {
    format: "integer"
}, _temp2);


export default Axis;